<template>
  <v-navigation-drawer
    color="primary"
    :value="$root.leftNav"
    app
    :mini-variant="mini"
    fixed
    persistent
    mobile-break-point="991"
    width="260"
  >
    <!-- <template v-slot:append>

    </template>-->
    <v-list class="py-0">
      <span v-for="(item, index) in allApplications" :key="`${item.name}_${index}`">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item v-on="on" :to="item.path" class="left-nav-item">
              <v-list-item-avatar class="text-center">
                <v-icon color="secondary secondary--text" class="md-icon">{{ item.meta.nav.icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-title class="secondary--text">{{ item.meta.nav.name }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{item.meta.nav.name}}</span>
        </v-tooltip>
      </span>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      mini: true
    }
  },
  props: {
    open: {
      default: true,
      required: true
    }
  },
  components: {
  },
  methods: {
  },
  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo',
      vg_user: 'auth/user'
    }),
    allApplications() {
      let allRoutes = this.$router.options.routes
      return allRoutes.filter((route) => {
        return route.meta && route.meta.nav && route.meta.nav.display
      })
    }
  }
}
</script>
<style scoped>
.branding-logo {
  max-width: 80%;
  height: 60px;
  width: auto;
}
</style>
